import { getArchiveIdByPostType, getFrontPageID, postTypeForRest } from '@/helpers/helpers'

const cacheVer = WPVUE.app_cache_version || Date.now();


const make404 = () => {
    console.log('%c PAGE NOT FOUND GO 404')
}

export default {

    loadPageByRoute({ commit, getters }) {
        if (!getters.pageIsLoading) return false
        const router = getters.getCurrentRoute
        if (!router) return false
        const currentPage = getters.currentPage
        if (currentPage) return false

        const postType = getters.currentPostType
        let pageSlug = router.path.replace(/\/$/, "").split('/')
        pageSlug = pageSlug[pageSlug.length - 1].replace(/\//g, "")
        const pageUrl = WPVUE.home_url + window.location.pathname

        getArchiveIdByPostType(postType)

        // fallback to wordpress REST posttypes for base post type
        const postTypeRest = postTypeForRest(postType);

        const loadById = (pageID) => axios.get('wp/v2/pages/' + pageID, {
            params: {
                cache: cacheVer
            }
        })

        const loadPost = (postType, pageSlug) => axios.get('wp/v2/' + postType, {
            params: {
                slug: pageSlug,
                cache: cacheVer
            }
            
        })

        let action = null

        switch (router.meta.type) {
            case 'single':
                action = loadPost(postTypeRest, pageSlug)
                break;

            case 'frontPage':
                action = loadById(getFrontPageID())
                break;

            case 'archive':
                const archiveID = getArchiveIdByPostType(postType)
                action = loadById(archiveID)
                break;

            default:
                //console.log('Unknown action...')
                break;
        }

        if (action && (typeof action === 'object')) {
            commit('CHANGE_PAGE_IS_LOADING', true)
            return action.then(res => {
                // it load by slug so it is array of objects
                let loadedData = null
                if (res && res.data && res.data.length > 0) {
                    loadedData = res.data.filter(item => (pageUrl.replace(/\/$/, "") === item.link.replace(/\/$/, "")))
                } else if (res && res.data) loadedData = [res.data]

                if (loadedData && loadedData.length > 0) {

                    commit('STORE_LOADED_PAGES', loadedData)

                } else make404()

                commit('CHANGE_PAGE_IS_LOADING', false)
            })
                .catch(res => {
                    console.warn('Error in load page function: ', res)
                    make404()
                    commit('CHANGE_PAGE_IS_LOADING', false)
                })
        }
        return null;
    },

    loadArchivePosts({ commit, getters }, nextPage) {

        const postType = getters.currentPostType
        const postTypeRest = postTypeForRest(postType);

        return axios.get('wp/v2/' + postTypeRest, {
            params: {
                page: nextPage,
                cache: cacheVer
            }
        }).then(res => {
            if (res && res.status === 200) {
                commit('STORE_LOADED_PAGES', res.data)
            } else console.warn('no response in loadArchivePosts', res)
            return res
        }).catch(res => {
            console.warn('Problem with loadArchive posts', res)
        })
    },

    loadRecentPosts({ commit, getters }, nextPage) {

        const postType = 'post'
        const postTypeRest = postTypeForRest(postType);

        return axios.get('wp/v2/' + postTypeRest, {
            params: {
                page: nextPage,
                cache: cacheVer
            }
        }).then(res => {
            if (res && res.status === 200) {
                commit('STORE_LOADED_PAGES', res.data)
            } else console.warn('no response in loadRecentPosts', res)
            return res
        }).catch(res => {
            console.warn('Problem with loadRecentPosts posts', res)
        })
    },

    loadNavigation({ commit }, location) {

        let menuLocation = location
        let endpoint = 'wp-api-menus/v2/'

        const endpointLocation = 'menu-locations/'
        const endpointID = 'menus/'

        if (Number.isInteger(location)) {
            endpoint = endpoint + endpointID
        } else {
            endpoint = endpoint + endpointLocation
        }

        return axios.get(endpoint + location, {
            params:{
                cache: cacheVer
            }
        })
            .then(res => {
                if (res && res.status === 200) {
                    let navigation = null
                    if (res.data.items) {
                        navigation = res.data.items
                    } else {
                        navigation = res.data
                    }
                    commit('STORE_LOADED_NAVIGATION', { navigation, menuLocation })

                    return navigation
                } else console.warn('There is something wrong in loadNavigation after then', res)
            }).catch(res => {
                console.warn('There is something wrong in loadNavigation', res)
            })
    },

    loadPostById({ commit, getters }, payload) {

        let postType = '';
        let postID = '';
        if (!payload) postType = 'post'

        if (payload && (typeof payload === 'object')) {
            postID = payload.id || '';
            postType = payload.postType || 'post';
        }

        const postTypeRest = postTypeForRest(postType)

        const currentPage = getters.getPostById(postID)
        if (currentPage) return currentPage

        axios.get('wp/v2/' + postTypeRest + '/' + postID,{
            params: {
                cache: cacheVer
            }
        })
            .then(res => {
                if (res && res.status === 200 && res.data) {
                    commit('STORE_LOADED_PAGES', [res.data])
                }
            })
            .catch(res => {
                console.warn('There is something wrong with loadPostById action', res)
            })


    },
    /**
     * 
     * @param {*} ids 
     */
    getPostsByIds({ commit }, ids) {
        axios.get('wpvue/v2/getById', {
            params: {
                ids,
                cache: cacheVer
            }
        }).then(res => {
            console.log(res);
        })
    },

    loadEverything({ commit, getters }) {

        if (getters.isLoadingEverything) return false

        commit('SET_LOADING_EVERYTHING', true)

        return axios.get('wpvue/v2/getEverything', {
            params: {
                cache: cacheVer
            }
        }).then(res => {

            if (res && res.status === 200) {

                commit('STORE_LOADED_PAGES', res.data.wp_posts)
                if (res.data.taxonomies) {
                    commit('STORE_LOADED_TAXONOMIES', res.data.taxonomies)
                }
                
                commit('CHANGE_PAGE_IS_LOADING', false)
                commit('SET_LOADED_EVERYTHING')

            } else console.warn('no response in loadEverything', res)

            commit('SET_LOADING_EVERYTHING', false)
            return res

        }).catch(res => {
            console.warn('Problem with loadEverything posts', res)
        })
    },

}